import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_START_INLINE_GAP,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

import { DrawerContentStyled } from "../drawer";

const DRAWER_GAP_MULTIPLIER = 2;

export const HistoryLogDrawerContentStyled = styled(
  DrawerContentStyled,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "history-log-drawer-content-styled",
})`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: calc(100vh - 200px);

  .Collapse-Header,
  .EntityProperties {
    padding-inline-start: ${DRAWER_START_INLINE_GAP}px;
  }

  & > div:not(:first-child):not(:last-child):before {
    content: "";
    display: inline-block;
    border-bottom: 1px solid ${rydeColors.grey};
    width: calc(100% - ${DRAWER_START_INLINE_GAP * DRAWER_GAP_MULTIPLIER}px);
    height: 8px;
    margin-inline: ${DRAWER_START_INLINE_GAP}px;
  }

  .entities-list__empty-state {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
  }

  .entities-list__empty-state-message {
    background-color: ${greyMui._50};
    border: 1px solid ${greyMui._200};
    border-radius: 8px;
    padding: 32px 40px;
    color: ${rydeColors.grey};
    font-size: 16px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    max-width: 500px;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-height: 140px;
    justify-content: center;
  }

  .entities-list__empty-state-icon {
    font-size: 32px;
    color: ${rydeColors.grey};
    opacity: 0.6;
  }

  .EntityHeader-Metadata {
    margin-inline-start: 0;
  }

  .audit-log-metadata-labels {
    margin-top: 10px;
    font-size: 11px;
  }
`;
